import { useContext } from "react";
import { ThemeContext } from "styled-components";

export const useThemeContext = () => {
  const theme = useContext(ThemeContext);

  return theme;
};
